module.exports = __webpack_public_path__ + "img/alphabet01.7ce1839a.png";